module.exports = __webpack_public_path__ + "img/1.023f5f7c.png";